import { h } from 'vue';

export default {
    // functional: true,

    render()
    {
        return h(
            'div',

            {
                // staticClass: data.staticClass,

                class: 'vh-modal-body',
            },

            this.$slots
        );
    },
};
